export const getTopPosition = (elem) => {
  const box = elem.getBoundingClientRect()
  const body = document.body
  const docElem = document.documentElement
  const scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop
  const clientTop = docElem.clientTop || body.clientTop || 0
  const top = box.top + scrollTop - clientTop
  return Math.round(top)
}

export const phoneValid = (value) => value ? value.replace(/\D/g, '').length === 12 && value.replace(/\D/g, '').substr(0, 3) === '375' : true

export const textFieldValid = (value) => value ? /[^a-zA-Zа-яА-Я ё!&?:;\-.,()"'\d\r\n]/.test(value) === false : true

export const emailOrTrue = value => value
  ? /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/.test(value)
  : true
